import { render, staticRenderFns } from "./ReplyDrawer.vue?vue&type=template&id=2c1bec25&"
import script from "./ReplyDrawer.vue?vue&type=script&lang=js&"
export * from "./ReplyDrawer.vue?vue&type=script&lang=js&"
import style0 from "./ReplyDrawer.vue?vue&type=style&index=0&id=2c1bec25&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/kivateknoloji/kivacloud/corona-ux/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c1bec25')) {
      api.createRecord('2c1bec25', component.options)
    } else {
      api.reload('2c1bec25', component.options)
    }
    module.hot.accept("./ReplyDrawer.vue?vue&type=template&id=2c1bec25&", function () {
      api.rerender('2c1bec25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inbox/components/ReplyDrawer.vue"
export default component.exports